<script type="text/jsx">
import mixin from '@/plans/mx/shopping-cart';
import planCommonMixin from '@/plans/EVENT_SAAS/mixin';
import { sortBy } from 'lodash';
import { pageConfig } from '@/common/service/page-config';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { isEventSaasOrEventSassCore } from '@/common/constants';

export default {
  mixins: [mixin, planCommonMixin],
  computed: {
    showRemove() {
      const fromPlanType = getPlanTypeByCategory(pageConfig.plan);
      return fromPlanType !== this.planType;
    },
    attendeesName() {
      return isEventSaasOrEventSassCore(this.planType) ? this.$t('billing.events.attendees', ['']) : this.$t('billing.participants');
    }
  },
  methods: {
    renderConsumptionPlanList(list = []) {
      if (!list.length) return;
      const plan = list[0];

      return <div class="opc-cart-item" key={plan.plan_code} >
        {this.mx_title(`${this.$t(plan.typeNameKey)} ${this.$t('billing.events.ppa.title')}`, this.mx_price(plan), plan?.plan_code)}
        {this.mx_discount(plan.plan_code)}
        {this.renderAttendeeDesc(plan)}
        {this.mx_edit(plan)}
        {this.showRemove ? this.mx_remove(plan) : null}
      </div>
    },
    renderSaasPlanList(list = []) {
      if (!list.length) return;
      const targetItem = list.some(plan => !!plan.isOnlineFreeTrial)
      return <div class="opc-cart-item">
        {/* FREE TRIAL - Specific UI for free trial */}
        { targetItem?
          this.mx_freeTrialTitle(this.title, targetItem?.parent_category) : this.mx_main_title(this.title, undefined, targetItem?.parent_category)}
        {sortBy(list, 'capacity').map((plan) => {
          return this.renderSaasPlan(plan);
        })}
      </div>
    },
    renderSaasPlan(plan) {
      if(!plan || !plan.cartInfo) return null;
      const quantity = plan.cartInfo.selected_number;
      {/* FREE TRIAL - Specific UI for free trial */}
      if(!!plan.isOnlineFreeTrial && !!plan.trialDays) {
        return (
            <div key={plan.plan_code} >
              {this.mx_license(quantity, this.$t('billing.planform.unit.license'))}
              {this.mx_freeTrialDesc(plan.trialDays)}
              {this.mx_cycle(plan.billing_cycle)}
              {this.mx_edit(plan)}
              {this.showRemove ? this.mx_remove(plan) : null}
            </div>
        )
      }
      return (
        <div key={plan.plan_code} >
          {this.mx_subTitle(`${plan.capacity} ${this.attendeesName}`, this.mx_price(plan), plan?.plan_code)}
          {this.mx_discount(plan.plan_code)}
          {this.mx_license(quantity)}
          {this.mx_cycle(plan.billing_cycle)}
          {this.mx_edit(plan)}
          {this.showRemove ? this.mx_remove(plan) : null}
        </div>
      );
    },
    renderAttendeeDesc(plan) {
      return <p class="opc-cart-item__attendee">{plan.capacity} {this.attendeesName}</p>
    },
    $renderPrice() {
      const saasPlans = this.mx_plans.filter((p) => p.isSaas);
      const ppaPlans = this.mx_plans.filter((p) => p.isPPA);

      return <div>
        {this.renderSaasPlanList(saasPlans)}
        {this.renderConsumptionPlanList(ppaPlans)}
      </div>
    },
    $renderAgreement() {
      return <div class="opc-cart-item__text"></div>;
    },
  },
};
</script>

<style lang="scss">
.opc-cart-item {
  &__attendee {
    color: #515079;
    font-family: Almaden Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 21px */
    text-transform: capitalize;
  }

  &__unit {
    color: #515079;
    font-family: Almaden Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 21px */
  }
}
</style>
